<template>
  <div>
    <v-col
      cols="12"
      md="12"
    >
      <base-material-card
        color="success"
        class="px-5 py-3"
      >
        <template v-slot:heading>
          <div class="text-h3 font-Wweight-light">
            Participación por contacto:
          </div>
        </template>
        <v-card-text>
          <apexchart
            width="800"
            type="donut"
            :options="computedChartOptions"
            :series="computedSeries"
          >
          </apexchart>
        </v-card-text>
      </base-material-card>
    </v-col>
  </div>
</template>

<script>
  import firebase from 'firebase'

  export default {
    data () {
      return {
        items: [],
        cantidadProyectos: 0,
      }
    },
    computed: {
      headers: function () {
        return [
          {
            sortable: true,
            text: 'Medio',
            value: 'medio',
          },
          {
            sortable: true,
            text: 'Cantidad',
            value: 'cantidad',
          },
        ]
      },
      computedSeries: function () {
        var series = []
        this.items.forEach(item => {
          series.push(item.cantidad)
        })
        return series
      },
      computedChartOptions: function () {
        var options = {
          labels: [],
        }
        this.items.forEach(item => {
          options.labels.push(item.medio)
        })
        return options
      },
    },
    mounted () {
      var proyectos = []
      var cantidadProyectos = 0
      var data = []
      firebase.firestore().collection('proyectos').where('fase', '==', 2).get().then(results => {
        results.forEach(result => {
          cantidadProyectos = cantidadProyectos + 1
          proyectos.push({
            codigo: result.data().codigo,
            medioContacto: result.data().medioContacto,
          })
          const medioContacto = this.$store.state.medioContacto
          medioContacto.forEach(medio => {
            var i = 0
            proyectos.forEach(proyecto => {
              if (proyecto.medioContacto === medio) {
                i = i + 1
              }
            })
            data.push({
              medio: medio,
              cantidad: i,
            })
            var helper = {}
            this.items = data.reduce(function (r, o) {
              var key = o.medio
              if (!helper[key]) {
                helper[key] = Object.assign({}, o)
                r.push(helper[key])
              } else {
                helper[key].cantidad = o.cantidad
              }
              return r
            }, [])
          })
        })
      })
      this.cantidadProyectos = cantidadProyectos
    },
  }
</script>
